'use strict';

wbApp.filter('sumFlt', [
    function () {
        return function (data, propertyName) {
            var sum = 0;
            if (!data || !propertyName) {
                return sum;
            }

            for (var i = 0; i < data.length; i++) {
                var row = data[i];
                var val = row[propertyName];
                if (val) {
                    sum += val;
                }
            }

            return sum;
        }
    }]);